export type SortDirection = "asc" | "desc";

const getTime = (value: string | number | Date | null | undefined) => {
  if (!value) return 0;

  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

export function sortByDate<T>(
  items: T[],
  getDateValue: (item: T) => string | number | Date | null | undefined,
  direction: SortDirection,
): T[] {
  return [...items].sort((a, b) => {
    const dateA = getTime(getDateValue(a));
    const dateB = getTime(getDateValue(b));

    return direction === "desc" ? dateB - dateA : dateA - dateB;
  });
}
